<template>
  <div class="car-park-base-info-dia">
    <el-dialog
      :title="title"
      :visible.sync="showDialogForm"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="64%"
      @closed="handleClose"
    >
      <el-tabs
        ref="parkInfoTabs"
        v-model="activeName"
        @tab-click="handleClick"
        v-if="showV4wardInfo"
      >
        <el-tab-pane name="parkRegion">
          <span slot="label"><span style="color: red">*</span>车场区域</span>
          <template v-show="activeName === 'parkRegion'">
            <park-region
              ref="regionDialog"
              :showBaseForm="showBaseForm"
              :parkSpace="parkSpace"
            ></park-region>
          </template>
        </el-tab-pane>
        <el-tab-pane name="passRule">
          <span slot="label"><span style="color: red">*</span>通行规则</span>
          <template v-if="activeName === 'passRule'">
            <park-pass-rule :parkSpace="parkSpace"></park-pass-rule>
          </template>
        </el-tab-pane>
        <el-tab-pane name="parkPassage">
          <span slot="label"><span style="color: red">*</span>通道</span>
          <template v-if="activeName === 'parkPassage'">
            <park-passage :parkSpace="parkSpace"></park-passage>
          </template>
        </el-tab-pane>
        <el-tab-pane name="parkDevice">
          <span slot="label"><span style="color: red">*</span>设备</span>
          <template v-if="activeName === 'parkDevice'">
            <park-device :parkSpace="parkSpace"></park-device>
          </template>
        </el-tab-pane>
        <el-tab-pane name="sentryBox">
          <span slot="label"><span style="color: red">*</span>岗亭</span>
          <template v-if="activeName === 'sentryBox'">
            <park-sentry-box :parkSpace="parkSpace"></park-sentry-box>
          </template>
        </el-tab-pane>
        <el-tab-pane name="parkUser">
          <span slot="label"><span style="color: red">*</span>岗亭人员</span>
          <template v-if="activeName === 'parkUser'">
            <park-user :parkSpace="parkSpace"></park-user>
          </template>
        </el-tab-pane>
        <el-tab-pane name="tempCarRule">
          <span slot="label"><span style="color: red">*</span>临停收费规则</span>
          <template v-if="activeName === 'tempCarRule'">
            <park-temp-car-fee-rule :parkSpace="parkSpace"></park-temp-car-fee-rule>
          </template>
        </el-tab-pane>
        <el-tab-pane name="clientParam">
          <span slot="label"><span style="color: red">*</span>车场参数配置</span>
          <template v-if="activeName === 'clientParam'">
            <park-v4ward-settings :parkSpace="parkSpace"></park-v4ward-settings>
          </template>
        </el-tab-pane>
        <el-tab-pane label="车位管理" name="parkParkingSpace">
          <template v-if="activeName === 'parkParkingSpace'">
            <park-parking-space :parkSpace="parkSpace"></park-parking-space>
          </template>
        </el-tab-pane>
        <el-tab-pane label="节假日管理" name="holiday">
          <template v-if="activeName === 'holiday'">
            <park-holiday-rule :parkSpace="parkSpace"></park-holiday-rule>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-tabs
        ref="parkInfoTabs2"
        v-model="activeName"
        @tab-click="handleClick"
        v-if="!showV4wardInfo"
      >
        <el-tab-pane name="parkRegion">
          <span slot="label"><span style="color: red">*</span>车场区域</span>
          <template v-show="activeName === 'parkRegion'">
            <park-region
              ref="regionDialog"
              :showBaseForm="showBaseForm"
              :parkSpace="parkSpace"
            ></park-region>
          </template>
        </el-tab-pane>
        <el-tab-pane label="车位管理" name="parkParkingSpace">
          <template v-if="activeName === 'parkParkingSpace'">
            <park-parking-space :parkSpace="parkSpace"></park-parking-space>
          </template>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import parkRegion from '@/views/v4ward/carv2/merge/park-region';
import parkPassRule from '@/views/v4ward/carv2/merge/park-pass-rule';
import parkPassage from '@/views/v4ward/carv2/merge/park-passage';
import parkDevice from '@/views/v4ward/carv2/merge/park-device';
import parkSentryBox from '@/views/v4ward/carv2/merge/park-sentry-box';
import parkUser from '@/views/v4ward/carv2/merge/park-user';
import parkTempCarFeeRule from '@/views/v4ward/carv2/merge/park-temp-car-fee-rule';
import parkV4wardSettings from '@/views/v4ward/carv2/merge/park-v4ward-settings';
import parkParkingSpace from '@/views/v4ward/carv2/merge/park-parking-space';
import parkHolidayRule from '@/views/v4ward/carv2/merge/park-holiday-rule';
export default {
  name: 'carParkBaseInfo.vue',
  components: {
    parkHolidayRule,
    parkRegion,
    parkPassage,
    parkPassRule,
    parkDevice,
    parkSentryBox,
    parkUser,
    parkTempCarFeeRule,
    parkV4wardSettings,
    parkParkingSpace,
  },
  data() {
    return {
      title: '车场配置',
      showDialogForm: false,
      showV4wardInfo: false,
      activeName: 'parkRegion',
      parkSpace: null,
      showBaseForm: false,
      spaceId: '',
      parkBaseInfoForm: {},
      rules: {},
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleClick(tab, event) {},
    //打开对话框
    openDialogForm(row) {
      console.log('=========');
      this.parkSpace = row;
      this.showV4wardInfo = row.equType === 4 || row.equType === 6;
      this.showBaseForm = true;
      this.spaceId = this.parkSpace.id;
      this.showDialogForm = true;
      this.title = '车场配置【' + row.spaceName + '】';
      setTimeout(() => {
        this.$refs.regionDialog.cleanForm();
        this.$refs.regionDialog.showParkForm = false;
      }, 0);
    },
    //关闭对话框
    handleClose() {
      this.activeName = 'parkRegion';
      this.$refs.regionDialog.showBaseForm = false;
      this.showBaseForm = false;
      this.showDialogForm = false;
    },
  },
};
</script>

<style scoped>
/*  .car-park-base-info-dia .el-dialog__body {
    padding-top: 0 !important;
  }*/

/*.el-divider--horizontal {
  margin: 8px 0;
  background: 0 0;
  border-top: 1px solid #e8eaec;
}

.el-dialog__body .el-col {
  margin-bottom: 2px;
  margin-top: 2px;
}
.fee-return-dia .el-dialog__body {
  padding: 10px 60px 20px 50px;
}
.money-text-align .el-input--small .el-input__inner {
  text-align: center;
}
.avue-crud__menu {
  min-height: 10px;
}
.self-label .el-form-item__label {
  font-size: 14px;
}
.self-input-red input.el-input__inner {
  color: red;
  font-size: 20px;
  background-color: #f3f3f3;
}
.avue-crud__pagination {
  position: relative;
  height: 0;
  margin-top: 0;
  margin-bottom: 0 !important;
  padding: 0 0;
}*/
</style>
